import type { ReactNode } from 'react'

export const fieldCls = 'w-full px-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white text-sm'
export const labelCls = 'block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1'

// Shared chrome for the invoice action dialogs (Void / Credit Note / Edit / Authorise), stacked
// above InvoiceDetailModal (z-50) at z-[60].
export default function InvoiceDialogShell({ title, tone = 'neutral', width = 'max-w-md', children, footer }: {
  title: string
  tone?: 'neutral' | 'danger' | 'warn'
  width?: string
  children: ReactNode
  footer: ReactNode
}) {
  const toneCls = tone === 'danger' ? 'text-red-700 dark:text-red-300' : tone === 'warn' ? 'text-amber-700 dark:text-amber-300' : 'text-gray-900 dark:text-white'
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full ${width} max-h-[90vh] overflow-y-auto`}>
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h3 className={`font-semibold ${toneCls}`}>{title}</h3>
        </div>
        <div className="p-6 space-y-4">{children}</div>
        <div className="px-6 pb-5 pt-3 flex gap-3 justify-end border-t border-gray-200 dark:border-gray-700">{footer}</div>
      </div>
    </div>
  )
}

export function ErrorBox({ message }: { message: string | null }) {
  if (!message) return null
  return <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 text-sm rounded-lg p-3">{message}</div>
}

export const btnCancel = 'px-4 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
